import React from 'react';

type MainProps = {
  children?: JSX.Element;
};

export const Main: React.FC<MainProps> = ({ children }) => {
  return <main className="flex flex-col h-full">{children}</main>;
};
